/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Financial } from '../../models/financial';

export interface FinancialEncounterNoteDetail$Params {
  PatientId?: string | null;
  PracticeId?: string | null;
  ID?: string | null;
  Type?: string | null;
}

export function financialEncounterNoteDetail(http: HttpClient, rootUrl: string, params?: FinancialEncounterNoteDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<Financial>> {
  const rb = new RequestBuilder(rootUrl, financialEncounterNoteDetail.PATH, 'get');
  if (params) {
    rb.query('PatientId', params.PatientId, {});
    rb.query('PracticeId', params.PracticeId, {});
    rb.query('ID', params.ID, {});
    rb.query('Type', params.Type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Financial>;
    })
  );
}

financialEncounterNoteDetail.PATH = '/financial/encounterNoteDetail';
